import { z } from "zod";
import { patientApi } from "./ApiClient";

const jwtSchema = z.object({ baseUrl: z.string(), token: z.string() });

export const getEmployeeJwt = async (employeeNumber: string) => {
  if (!employeeNumber) {
    return Promise.reject(new Error("Invalid employee number"));
  }

  const url = `/employees/${employeeNumber}/chat/token`;
  return await patientApi.post(url).json(jwtSchema);
};
